import { Stack, SxProps } from "@mui/material";

interface IBybList {
  children: React.ReactNode;
  sx?: SxProps;
}

const BybList = ({ children, sx }: IBybList) => {
  return <Stack sx={{ marginY: 0.75, ...sx }}>{children}</Stack>;
};

export default BybList;
